<template>
  <div class="footer">
    <div class="footer-inner-wrap">
      <!-- Logo Section -->
      <div class="footer-logo-wrap">
        <a href="https://selacloud.com">
          <img
            src="@/assets/footer logo.svg"
            alt="Sela"
          />
        </a>
      </div>
<div class="footer-wrapper">
  
        <!-- Footer Content - Desktop and Mobile -->
        <div class="footer-content">
          <!-- Services Section -->
          <div class="footer-section">
            <div class="footer-section-header" @click="toggleSection('services')">
              <h3>Services</h3>
              <span class="dropdown-arrow" :class="{ expanded: expandedSections.services }">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
            <div class="footer-section-content" :class="{ expanded: expandedSections.services }">
              <a href="/support" class="footer-link">Cloud Management Services</a>
              <a href="/solutions/devops-as-a-service" class="footer-link">DevOps</a>
              <a href="/solutions/security" class="footer-link">Security</a>
              <a href="/solutions/cloud-architecture" class="footer-link">Cloud Architecture</a>
              <a href="/solutions/cloud-migration" class="footer-link">Cloud Migration & Modernization</a>
              <a href="/solutions/revolutionize-your-business-with-ai-cloud-services" class="footer-link">Data & AI</a>
              <a href="/solutions/finops-as-a-service" class="footer-link">FinOps</a>
              <a href="/solutions/monitoring-support-as-a-service" class="footer-link">Support & Monitoring</a>
              <a href="/skilling" class="footer-link">Skilling</a>
            </div>
          </div>
  
          <!-- Solutions Section -->
          <div class="footer-section">
            <div class="footer-section-header" @click="toggleSection('solutions')">
              <h3>Solutions</h3>
              <span class="dropdown-arrow" :class="{ expanded: expandedSections.solutions }">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
            <div class="footer-section-content" :class="{ expanded: expandedSections.solutions }">
              <a href="/solutions/genai-adoption" class="footer-link">GenAI Adoption Solution</a>
              <a href="solutions/ai-chatbot-company-data" class="footer-link">AI Chatbot over Company Data</a>
              <a href="/solutions/marketplace" class="footer-link">Marketplace Solutions</a>
              <a href="/solutions/landing-zones" class="footer-link">Landing Zones Solutions</a>
            </div>
          </div>
  
          <!-- Resources Section -->
          <div class="footer-section">
            <div class="footer-section-header" @click="toggleSection('resources')">
              <h3>Resources</h3>
              <span class="dropdown-arrow" :class="{ expanded: expandedSections.resources }">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
            <div class="footer-section-content" :class="{ expanded: expandedSections.resources }">
              <a href="/events" class="footer-link">Events</a>
              <a href="/insights" class="footer-link">Blog</a>
              <a href="/customers" class="footer-link">Customer Stories</a>
              <a href="/podcasts" class="footer-link">Podcasts</a>
            </div>
          </div>
  
          <!-- About Section -->
          <div class="footer-section">
            <div class="footer-section-header" @click="toggleSection('about')">
              <h3>About</h3>
              <span class="dropdown-arrow" :class="{ expanded: expandedSections.about }">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
            <div class="footer-section-content" :class="{ expanded: expandedSections.about }">
              <a href="/about" class="footer-link">About us</a>
              <div class="partners-section">
                <div class="partners-header" @click="togglePartners">
                  <span>Partners</span>
                  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" class="PartnersArrow">
                    <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="partners-content expanded">
                  <a href="/aws" class="partner-link">
                    <img src="https://selacloud.com/logos/AWS.png" alt="AWS" class="partner-icon" />
                    AWS
                  </a>
                  <a href="/google-cloud" class="partner-link">
                    <img src="https://selacloud.com/logos/Google-Cloud.png" alt="Google Cloud" class="partner-icon" />
                    Google Cloud
                  </a>
                  <a href="/azure" class="partner-link">
                    <img src="https://selacloud.com/logos/Microsoft-Azure.png" alt="Microsoft Azure" class="partner-icon" />
                    Microsoft Azure
                  </a>
                  <a href="/alibaba" class="partner-link">
                    <img src="https://selacloud.com/logos/Alibaba-Cloud.png" alt="Alibaba Cloud" class="partner-icon" />
                    Alibaba Cloud
                  </a>
                </div>
              </div>
              <a href="/in-the-news" class="footer-link">Newsroom</a>
              <a href="/careers" class="footer-link">Careers <span class="hiring-badge">We're Hiring!</span></a>
            </div>
          </div>
  
          <!-- Legal Section -->
          <div class="footer-section">
            <div class="footer-section-header" @click="toggleSection('legal')">
              <h3>Legal</h3>
              <span class="dropdown-arrow" :class="{ expanded: expandedSections.legal }">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
            <div class="footer-section-content" :class="{ expanded: expandedSections.legal }">
              <a href="/legal/ethical-code" class="footer-link">Code of Ethics</a>
              <a href="/legal/esg" class="footer-link">ESG Policy</a>
              <a href="/legal/privacy-policy" class="footer-link">Privacy Policy</a>
              <a href="/legal/iso9001-sela.pdf" class="footer-link">ISO 9001</a>
              <a href="/legal/iso27001-sela.pdf" class="footer-link">ISO 27001</a>
              <a href="/legal/accessibility" class="footer-link">Accessibility</a>
              <a href="https://portal.selacloud.com/#/passport/login" class="footer-link service-portal-link login">Service Portal login ></a>
            </div>
          </div>
          <a href="https://portal.selacloud.com/#/passport/login" class="footer-link service-portal-link mobileLogin">Service Portal login ></a>
        </div>

        <!-- Contact Info and Social Links -->
        <div class="footer-contact-section">
          <div class="footer-contact-info">
            <div class="contact-info">
              <a href="mailto:info@selacloud.com" class="contact-link">info@selacloud.com</a>
              <a href="tel:+14843690439" class="contact-link">US: +1 484-369-0439</a>
              <!-- <a href="tel:+97236176666" class="contact-link">Israel: +972 3-6176666</a> -->
            </div>
                    <div class="footer-soc-links">
          <a
            :href="social.link"
            target="_blank"
            class="soc-link footer-social-link"
            v-for="social in settings.socialLinks"
            :key="social._id"
          >
            <img
              :src="social.icon.imageURL"
              :alt="social.title"
            /></a>
</div>
    
          </div>
        </div>
</div>

      <!-- Footer Bottom -->
      <div class="footerGradient"></div>
      <div class="footer-bottom">
        <div class="footer-copyright">
          <span><span class="Copyright">Copyright</span> © {{ currentYear }} - Sela</span>
        </div>
        <div class="footer-certifications">
         <a href="/legal/iso9001-sela.pdf" class="">
           <img src="../assets/ISO-9001.png" alt="ISO 9001" class="cert-badge" />
         </a>
         <a href="/legal/iso27001-sela.pdf" class="">
           <img src="../assets/ISO-27001.png" alt="ISO 27001" class="cert-badge" />
         </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildPath } from "@/utils/buildPath";

export default {
  data() {
    return {
      expandedSections: {
        services: false,
        solutions: false,
        resources: false,
        about: false,
        legal: false
      },
      showPartners: false,
      isMobile: false
    };
  },
  computed: {
    settings() {
      return this.$local.websiteSettings;
    },
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    buildPath,
    toggleSection(sectionName) {
      if (this.isMobile) {
        this.expandedSections[sectionName] = !this.expandedSections[sectionName];
      }
    },
    togglePartners() {
      if (this.isMobile) {
        this.showPartners = !this.showPartners;
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
      
      // On desktop, ensure all sections are expanded
      if (!this.isMobile) {
        Object.keys(this.expandedSections).forEach(key => {
          this.expandedSections[key] = true;
        });
        this.showPartners = true;
      } else {
        // On mobile, collapse all sections by default
        Object.keys(this.expandedSections).forEach(key => {
          this.expandedSections[key] = false;
        });
        this.showPartners = false;
      }
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  name: "botfooter",
};
</script>

<style scoped>
.footer {
  background-color: #2D3034;
  color: #ffffff;
  padding: 60px 0 30px;
  min-height: 400px;
}

.footer-inner-wrap {
  max-width: 1200px;
  width: 98%;
  margin: 0 auto;
  /* padding: 0 20px; */
}

/* Logo Section */
.footer-logo-wrap {
  margin-bottom: 40px;
}

.footer-logo-wrap img {
  max-height: 30px;
  width: auto;
}

/* Footer Content */
.footer-content {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 40px;
  margin-bottom: 60px;
}

/* Footer Sections */
.footer-section {
  position: relative;
}

.footer-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  cursor: pointer;
}

.footer-section-header h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;  
  opacity: 0.5;
}

.dropdown-arrow {
  display: none;
  transition: transform 0.3s ease;
}

.dropdown-arrow svg {
  color: #9ca3af;
}

.dropdown-arrow.expanded {
  transform: rotate(180deg);
}

.footer-section-content {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  align-items: flex-start;
}
.soc-link.footer-social-link{
  padding: 0.05rem;
  background: #fff;
  border-radius: 100%;
  margin: 0;
}

.footer-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 12px;
  font-weight: 300;
  line-height: 1.5;
  transition: color 0.3s ease;
  display: block;
}

.footer-link:hover {
  /* color: #60d9ef; */
}
.partner-link{
      border-bottom: 1px solid transparent;
}
.partner-link:hover{
      border-bottom: 1px solid white;
}
.PartnersArrow{
  transform: rotate(0deg) scale(0.5);
}

.service-portal-link {
  color: #60d9ef !important;
  font-weight: 500;
}

/* Partners Section */
.partners-section {
  /* margin: 20px 0; */
}

.partners-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #ffffff;
  font-size: 12px;
  margin-bottom: 12px;
}

.partners-header svg {
  transition: transform 0.3s ease;
}

.partners-header svg.expanded {
  transform: rotate(180deg);
}

.partners-content {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  align-items: flex-start;
}

.partner-link {
  display: flex;
  align-items: center;
  gap: 3px;
  color: #ffffff;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s ease;
  font-weight: 300;
}
.partner-link img{
     height: 16px;
    width: auto;
    background: #fff;
    padding: .125rem;
    border-radius: 3px;
    margin-inline-end: .25rem;
}

.partner-link:hover {
  /* color: #60d9ef; */
}

.partner-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.hiring-badge {
  color: #60d9ef;
}

/* Contact Section */
.footer-contact-section {
  /* border-top: 1px solid #6b7280; */
  /* padding-top: 30px;
  margin-bottom: 30px; */
}

.footer-contact-info {
  /* display: flex; */
  /* justify-content: space-between; */
  /* align-items: center; */
  /* flex-wrap: wrap; */
  /* gap: 20px; */
  flex-grow: 1;
  flex-shrink: 0;
  min-width: 180px;
}

.contact-info {
  display: flex;
  flex-direction: column;
}

.contact-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
  padding-bottom: 0.3rem;
}

.contact-link:hover {
  color: #60d9ef;
}

.footer-social-links {
  display: flex;
  gap: 16px;
}

.social-link {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  color: #484c53;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-link:hover {
  background-color: #60d9ef;
  transform: translateY(-2px);
}

.social-link svg {
  width: 20px;
  height: 20px;
}

/* Footer Bottom */
.footer-bottom {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-copyright {
  font-size: 12px;
  font-weight: 300;
}

.footer-certifications {
  display: flex;
  gap: 16px;
}
.footer-soc-links{
  gap: 0.4rem;
  display: flex;
}
.cert-badge {
  height: 40px;
  width: auto;
  transition: opacity 0.3s ease;
}

.cert-badge:hover {
  opacity: 0.8;
}
.footerGradient{
      background: linear-gradient(90deg, #fff, #fff0);
    height: 1px;
    width: 100%;
}
.footer-wrapper {
  display: flex;
  gap: 6rem;
}
  .mobileLogin {
    display: none;
  }

/* Mobile Styles */
@media (max-width: 910px) {
  .footer-link.service-portal-link.login{
    display: none;
  }
  .mobileLogin {
    display: block;
    font-size: 14px;
    text-decoration: underline;
    font-weight: 500;
    text-align: start;
    padding-top: 1rem;
  }
  .footer-section-header h3 {
  font-size: 14px;
  font-weight: 400;
  margin: 0;  
}
  .cert-badge {
  height: 50px;
  width: auto;
  transition: opacity 0.3s ease;
}
  .Copyright{
    display: none;
  }
  .footer-soc-links{
  justify-content: flex-end;
  padding-bottom: 1rem;
    gap: 0.7rem;

}

  .footer-wrapper {
  /* display: flex;
  */
  gap: 1rem;
  flex-direction: column ;
}

.contact-info{
  display: none;
}
.footer-logo-wrap {
  text-align: start;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
  .footer {
    padding: 40px 0 20px;
  }

  .footer-inner-wrap {
    padding: 0 16px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 0;
    margin-bottom: 40px;
  }

  .footer-section {
    border-bottom: 1px solid #6b7280;
  }



  .footer-section-header {
    cursor: pointer;
    padding-block: 0.75rem;
    margin: 0;
    padding-inline-end: 0.5rem;
  }

  .dropdown-arrow {
    display: block;
    scale: 0.6;
  }

  .footer-section-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }

  .footer-section-content.expanded {
    max-height: 500px;
    margin-bottom: 16px;
  }

  .partners-header {
    margin-bottom: 0;
  }

  .partners-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }

  .partners-content.expanded {
    max-height: 200px;
    margin-top: 12px;
  }

  .footer-contact-info {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-info {
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .footer-social-links {
    align-self: flex-start;
  }

  .footer-bottom {
    /* align-items: flex-start; */
    gap: 16px;
  }

  .footer-certifications {
    gap: 0.5rem;
    align-self: flex-end;
  }
  .soc-link.footer-social-link {
    padding: 0rem;
    scale: 0.8;
}
}

</style>
